import { Pipe, PipeTransform } from '@angular/core';
import {STRIPE_ACCOUNTS} from '../../lookups/stripeAccounts';
import {PaymentAccount} from '../../models/payments/paymentAccount.model';
import {environment} from '../../../environments/environment';

@Pipe({
  name: 'stripeDashboardLink'
})
export class StripeDashboardLinkPipe implements PipeTransform {

  transform(legalCompany: string, brand: string): string {
    const account: PaymentAccount = STRIPE_ACCOUNTS[legalCompany][brand];
    return account? `https://dashboard.stripe.com${environment.production? '': '/test'}/dashboard?account_id=${account.accountId}`: '';
  }

}
